export default {
  props: {
    h: {
      type: [Number, String],
      default: 0
    }
  }
};